
import ThumbHover from './thumb-houver';
export default ThumbHover;
export { ThumbHover };
